// extracted by mini-css-extract-plugin
export var clickLogoText = "labLogos-module--clickLogoText--3HLmQ";
export var contentWrapper = "labLogos-module--contentWrapper--D6RM0";
export var lensManufacturersHeader = "labLogos-module--lensManufacturersHeader--SIY-e";
export var lensManufacturersHeaderWrapper = "labLogos-module--lensManufacturersHeaderWrapper--E0jxh";
export var links = "labLogos-module--links--AqW2O";
export var logosWrapper = "labLogos-module--logosWrapper--9662R";
export var wrapper = "labLogos-module--wrapper--rjSW6";